module.exports = __webpack_public_path__ + "static/closeIcon.f0368e6e.svg";